/* /client/src/pages/SalesDetailPage.js   */
/* Creates page for detail of one sale */

import React, { Component } from "react";
//import "./style.css"
import Nav           from "../components/Nav";
import DetButtonsBar from "../components/DetButtonsBar";
import ExchMasForm   from "../forms/ExchMasForm";
import ExchCaptModal from "../modals/ExchCaptModal";
import ExchDetForm   from "../forms/ExchDetForm";
import Footer        from "../components/Footer";
import Button        from "react-bootstrap/Button";
const usrFirstname = localStorage.getItem("firstname");
const usrLastname  = localStorage.getItem("lastname");
const usrEmail     = localStorage.getItem("email");

class SalesDetailPage extends Component {

   render() {
      return (
         <div className="">
            { ( (usrFirstname === null) || 
                (usrLastname  === null) || 
                (usrEmail     === null) ) ? window.location = "/" : null } 

            <Nav />

            <DetButtonsBar 
               title         = "Detail of Sales"
               urlList       = "/salesList/"
               action        = {this.props.state.master.action}
               btnCfgAddDis  = {this.props.state.DetButtonsBar.btnCfgAddDis}
               handleSubmit  = {this.props.handleSubmit}
               handleDelete  = {this.props.handleDelete}
            />

            <ExchMasForm 
               state                   = {this.props.state.master}
               handleChange            = {this.props.handleChange}
               checkMasterVal          = {this.props.checkMasterVal}
               checkValueDocId         = {this.props.checkValueDocId}
               checkValueAsocId        = {this.props.checkValueAsocId}
               handleFieldValidStatus  = {this.props.handleFieldValidStatus}
            />

            <br />

            { (this.props.state.showAddLineBtn) ?
                  <div className="text-center">
                     <Button size    = "sm"
                             variant = "outline-info"
                             onClick = {this.props.handleShowDetModal}
                     >
                        Add line
                     </Button>
                  </div>
              : null
            }

            <ExchCaptModal
               handleDetChange     = {this.props.handleDetChange}
               handleDetSubmit     = {this.props.handleDetSubmit}
               checkDetailVal      = {this.props.checkDetailVal}
               handleCloseDetModal = {this.props.handleCloseDetModal}
               show                = {this.props.state.showDetModal}
               lines               = {this.props.state.lines}
               state               = {this.props.state}
            />

            <ExchDetForm 
               arrLines = {this.props.state.arrLines} 
               action   = {this.props.state.action}
               handleShowDetModalEdit = {this.props.handleShowDetModalEdit}
            />

            <Footer
               msgs = {this.props.state.msgs}
            />

            <br />

         </div>
      );
   }
}

export default SalesDetailPage;